/* ============================================================
   Lunish theme — interactions
   ============================================================ */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  var sel = function (s, ctx) { return (ctx || document).querySelector(s); };
  var selAll = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  /* ---------- Cart helpers ---------- */
  function getCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderDrawer() {
    return fetch(routes.cart + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('shopify-section-cart-drawer');
        var current = document.getElementById('shopify-section-cart-drawer');
        if (next && current) current.innerHTML = next.innerHTML;
      });
  }

  function updateCount() {
    return getCart().then(function (cart) {
      selAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    });
  }

  /* ---------- Drawer open/close ---------- */
  function openDrawer() {
    if (theme.cartType === 'page') { window.location.href = routes.cart; return; }
    var d = sel('cart-drawer');
    if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeDrawer() {
    var d = sel('cart-drawer');
    if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  /* ---------- Add to cart ---------- */
  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-add-label]');
    var original = label ? label.textContent : '';
    if (button) button.disabled = true;
    if (label) label.textContent = '…';

    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || 'Error');
          return data;
        });
      })
      .then(function () {
        if (theme.cartType === 'page') { window.location.href = routes.cart; return; }
        return Promise.all([renderDrawer(), updateCount()]).then(openDrawer);
      })
      .catch(function (e) { alert(e.message); })
      .then(function () {
        if (button) button.disabled = false;
        if (label) label.textContent = original;
      });
  }

  /* ---------- Change a cart line (drawer) ---------- */
  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return Promise.all([renderDrawer(), updateCount()]); });
  }

  /* ---------- Variant selection (product page) ---------- */
  function handleVariantChange(select) {
    var opt = select.options[select.selectedIndex];
    var form = sel('[data-product-form]');
    if (form) { var idField = form.querySelector('[data-variant-id]'); if (idField) idField.value = select.value; }

    var priceEl = sel('.product__price .price');
    if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');

    var available = opt.getAttribute('data-available') === 'true';
    var addBtn = sel('[data-add-button]');
    var label = sel('[data-add-label]');
    if (addBtn) addBtn.disabled = !available;
    if (label) label.textContent = available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');

    // Cada presentacion es un ASIN distinto: el boton de Amazon sigue a la variante.
    var amazon = sel('[data-amazon-link]');
    var amazonUrl = opt.getAttribute('data-amazon-url');
    if (amazon) {
      if (amazonUrl) { amazon.href = amazonUrl; amazon.hidden = false; }
      else { amazon.hidden = true; }
    }
  }

  /* ---------- Quantity adjust ---------- */
  function adjustQty(wrap, delta) {
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var val = parseInt(input.value, 10) || 0;
    val = Math.max(min, val + delta);
    input.value = val;
    commitQty(input);
  }
  function commitQty(input) {
    if (input.closest('cart-drawer')) {
      var line = parseInt(input.getAttribute('data-line'), 10);
      changeLine(line, parseInt(input.value, 10) || 0);
    }
    // Cart page uses an explicit "update" button; product form submits with its own form.
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('[data-cart-add]')) { e.preventDefault(); addToCart(form); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    var pill = t.closest && t.closest('[data-variant-pill]');
    if (pill) {
      if (pill.getAttribute('data-available') === 'false') return;
      var grp = pill.parentNode;
      var pills = grp.querySelectorAll('[data-variant-pill]');
      for (var i = 0; i < pills.length; i++) { pills[i].classList.remove('is-active'); pills[i].setAttribute('aria-checked', 'false'); }
      pill.classList.add('is-active'); pill.setAttribute('aria-checked', 'true');
      var select = sel('[data-variant-select]');
      if (select) { select.value = pill.getAttribute('data-variant-id'); handleVariantChange(select); }
      return;
    }

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var minus = t.closest('[data-qty-minus]');
    var plus = t.closest('[data-qty-plus]');
    if (minus || plus) { e.preventDefault(); adjustQty(t.closest('.qty'), plus ? 1 : -1); return; }

    var remove = t.closest('[data-qty-remove]');
    if (remove) { e.preventDefault(); changeLine(parseInt(remove.getAttribute('data-line'), 10), 0); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = thumb.getAttribute('data-full');
      selAll('[data-thumb]').forEach(function (el) { el.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var menuToggle = t.closest('[data-menu-toggle]');
    if (menuToggle) {
      var mob = sel('[data-mobile-menu]');
      if (mob) {
        var isHidden = mob.hasAttribute('hidden');
        if (isHidden) { mob.removeAttribute('hidden'); } else { mob.setAttribute('hidden', ''); }
        menuToggle.setAttribute('aria-expanded', String(isHidden));
      }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-qty-input]')) commitQty(input);
    if (input.matches && input.matches('[data-variant-select]')) handleVariantChange(input);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Scroll reveal animations ---------- */
  function initReveal() {
    if (!theme.animations) return;
    if (!('IntersectionObserver' in window)) return;
    var targets = selAll('.section-heading, .card, .benefit, .flavor, .image-text__content, .faq__item, .hero__content');
    if (!targets.length) return;
    targets.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') initReveal();
  else document.addEventListener('DOMContentLoaded', initReveal);

  /* ---------- Slider auto-play ---------- */
  function initSliders() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    selAll('.slider').forEach(function (slider) {
      var originals = Array.prototype.slice.call(slider.children);
      if (originals.length < 2) return;
      // Clonar las tarjetas para un loop infinito en UN solo sentido (no se devuelve).
      originals.forEach(function (c) { slider.appendChild(c.cloneNode(true)); });
      var count = originals.length;
      var idx = 0, timer = null, resetting = false;
      function centerLeft(el) { return el.offsetLeft - (slider.clientWidth - el.offsetWidth) / 2; }
      function go() {
        if (resetting) return;
        idx++;
        var t = slider.children[idx];
        if (!t) { idx = 0; return; }
        slider.scrollTo({ left: centerLeft(t), behavior: 'smooth' });
        if (idx >= count) {
          // Llegó al clon del primero: tras la animación, salta instantáneo al inicio real (invisible).
          resetting = true;
          setTimeout(function () {
            slider.scrollTo({ left: centerLeft(slider.children[0]), behavior: 'auto' });
            idx = 0; resetting = false;
          }, 650);
        }
      }
      function start() { if (!reduce && !timer) timer = setInterval(go, 3500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('pointerdown', stop);
      start();
    });
  }
  if (document.readyState !== 'loading') initSliders();
  else document.addEventListener('DOMContentLoaded', initSliders);

  /* ---------- Títulos multicolor por palabra (estilo referencia) ---------- */
  function rainbowWords(h, outlined) {
    if (h.dataset.colored) return;
    var palette = ['#16365E', '#ED7D1B', '#1E8A8C', '#D81E5B', '#9B5DE5', '#7CB518'];
    h.dataset.colored = '1';
    h.classList.add('heading--rainbow');
    if (outlined) h.classList.add('heading--outlined');
    var words = h.textContent.trim().split(/\s+/);
    h.innerHTML = words.map(function (w, i) {
      return '<span style="color:' + palette[i % palette.length] + ';--wi:' + i + '">' + w + '</span>';
    }).join(' ');
  }
  function colorizeHeadings() {
    // Secciones claras: cada palabra un color de marca (saltamos bandas de color).
    selAll('.section-heading').forEach(function (h) {
      if (h.closest('.hero')) return;
      rainbowWords(h, !!(h.closest('.benefits--seals') || h.closest('.testimonials--beach')));
    });
    // Hero: multicolor con contorno para que se lea sobre el degradado.
    selAll('.hero--brand .hero__heading').forEach(function (h) { rainbowWords(h, true); });
  }
  if (document.readyState !== 'loading') colorizeHeadings();
  else document.addEventListener('DOMContentLoaded', colorizeHeadings);

  /* ---------- Performance: solo reproducir videos visibles ---------- */
  function initVideoLazy() {
    if (!('IntersectionObserver' in window)) return;
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else { try { v.pause(); } catch (err) {} }
      });
    }, { rootMargin: '120px 0px', threshold: 0.1 });
    function observeAll() { selAll('video').forEach(function (v) { if (!v.dataset.vlazy) { v.dataset.vlazy = '1'; vio.observe(v); } }); }
    observeAll();
    // re-observar videos creados dinámicamente (Real moments)
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { observeAll(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') initVideoLazy();
  else document.addEventListener('DOMContentLoaded', initVideoLazy);
})();
